import { CheckIcon } from 'lucide-react'
import { useCallback } from 'react'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

export const SelectButton = (props: {
  disabled: boolean
  className?: string
  checked: boolean
  onClick: () => void
}) => {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault()

      if (props.disabled) {
        return
      }

      props.onClick()
    },
    [props]
  )

  return (
    <Button
      className={cn(
        'focus-visible:bg-white focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-0 focus-visible:hover:bg-slate-100',
        'hover:bg-transparent'
      )}
      variant="ghost"
      size="sm"
      disabled={props.disabled}
      onClick={handleClick}
    >
      <div
        className={cn(
          'h-4 w-4 rounded border border-[hsla(240,_6%,_10%,_1)]',
          'flex items-center justify-center',
          'duration-50 transition-all',
          props.checked && 'bg-[hsla(240,_6%,_10%,_1)]'
        )}
      >
        <CheckIcon size={12} className="text-white" />
      </div>
    </Button>
  )
}
